function changeFormAction(oldAction, newAction) {
    var forms = document.querySelectorAll('.wp-block-sensei-lms-button-take-course form');

    for (var i = 0; i < forms.length; i++) {
        if (forms[i].action === oldAction) {
            // Change all the forms with the same oldAction URL
            forms[i].action = newAction;
        }
    }
}

var baseUrl = window.location.protocol + '//' + window.location.host;

var oldActionURL = baseUrl + "/my-courses/"; // Replace with the old action URL
var newActionURL = baseUrl + "/login/"; // Replace with the desired action URL

window.onload = function() {
    changeFormAction(oldActionURL, newActionURL);
};
